import type { BattleLoadProgress } from '../loading/battle-load-progress';

/** The live status stays outside aria-busy so screen readers hear each stage. */
export function createLoadProgress(doc: Document) {
  const root = doc.createElement('section');
  root.className = 'main-menu-load';
  root.dataset.testid = 'menu-load-progress';
  root.setAttribute('aria-label', 'Подготовка поля боя');
  root.hidden = true;
  const stages = doc.createElement('ol');
  stages.className = 'main-menu-load-stages';
  for (const label of ['Загрузка', 'Подготовка', 'Готовность']) {
    const item = doc.createElement('li');
    item.textContent = label;
    stages.append(item);
  }
  const status = doc.createElement('p');
  status.className = 'main-menu-load-label';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-atomic', 'true');
  const progress = doc.createElement('progress');
  progress.setAttribute('aria-label', 'Загруженная техника');
  const detail = doc.createElement('p');
  detail.className = 'main-menu-load-detail';
  root.append(stages, status, progress, detail);
  return {
    root,
    update(value: BattleLoadProgress) {
      root.hidden = false;
      root.dataset.phase = value.phase;
      const stage =
        value.phase === 'runtime' || value.phase === 'download'
          ? 0
          : value.phase === 'models' || value.phase === 'scene'
            ? 1
            : 2;
      [...stages.children].forEach((node, index) => {
        if (index === stage) node.setAttribute('aria-current', 'step');
        else node.removeAttribute('aria-current');
        node.classList.toggle('complete', index < stage);
      });
      progress.removeAttribute('value');
      progress.removeAttribute('max');
      if (value.phase === 'download') {
        progress.max = value.total;
        progress.value = value.loaded;
        const megabytes = (bytes: number) => (bytes / 1_000_000).toFixed(1);
        status.textContent = `Загрузка: ${Math.floor((value.loaded / value.total) * 100)}%`;
        detail.textContent = `${megabytes(value.loaded)} из ${megabytes(value.total)} МБ · техника и здания ФОК`;
      } else if (value.phase === 'models') {
        progress.max = value.total;
        progress.value = value.completed;
        status.textContent = `Техника: ${value.completed} из ${value.total}`;
        detail.textContent = value.name
          ? `Подготовка: ${value.name}`
          : 'Файлы получены. Подготавливаем технику и здания.';
      } else if (value.phase === 'runtime') {
        status.textContent = 'Загружаем поле боя';
        detail.textContent =
          'Подготавливаем игровые файлы. Первый запуск может занять больше времени.';
      } else if (value.phase === 'scene') {
        status.textContent = 'Подготовка поля боя';
        detail.textContent = 'Создаём сцену и материалы.';
      } else {
        status.textContent = 'Подготовка первого кадра';
        detail.textContent = 'Бой откроется автоматически, когда поле и техника будут готовы.';
      }
    },
    hide() {
      root.hidden = true;
    },
  };
}
